import React from 'react'
import ReactDOM from 'react-dom'

import './global.scss'
import { App } from './components'

ReactDOM.render(<App />, document.getElementById('root'))
